import http from "../http-common";

class ReachoutNotificationService {
  createReachoutNotification(data: any, fromDate: string, toDate: string) {
    return http.post(
      `/crm/reachout?fromDate=${fromDate}&toDate=${toDate}`,
      data
    );
  }

  getReachoutNotifications(page: any, pageSize: any) {
    return http.get(`/crm/reachout?page=${page}&pageSize=${pageSize}`);
  }

  updateReachoutNotification(id: any, date: any, time: any, send_mode: any) {
    return http.patch(
      `/crm/reachout?id=${id}&date=${date}&time=${time}&send_mode=${send_mode}`
    );
  }

  getFilteredReachoutCount(
    data: any,
    type: any,
    sorting_order: any,
    range: any,
    send_mode: any,
    fromDate: any = null,
    toDate: any = null
  ) {
    return http.post(
      `/crm/reachout/filters?type=${type}&send_mode=${send_mode}&fromDate=${fromDate}&toDate=${toDate}`,
      {
        ...data,
        sorting_order,
        range,
      }
    );
  }

  getCampaigns() {
    return http.get(`/crm/reachout/campaignids`);
  }

  getSingleCampaign(id: any) {
    return http.get(`/crm/reachout/campaignid/${id}`);
  }
  getDeleteCampaign(id: any) {
    return http.delete(`/crm/reachout/${id}`);
  }
}

export default new ReachoutNotificationService();
